import { render, staticRenderFns } from "./TagItemInfoView.vue?vue&type=template&id=4205cbe4&"
import script from "./TagItemInfoView.vue?vue&type=script&lang=ts&"
export * from "./TagItemInfoView.vue?vue&type=script&lang=ts&"
import style0 from "./TagItemInfoView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports